import TemplateView from '../../../../TemplateView'
import {connect} from '../../../../redux/utils'
import {isTZGEnabled, isUGREnabled} from '../../../../features/selectors'
import {isOlVersion, isDemoVersion} from '../../../../constants'
import {isPossibleToCreateUsers, licenseViolated} from '../../common/selectors'
import ManageGroupsList from "./ManageGroupsList";
import ManageGroupsButton from './ManageGroupsButton'
import AnimatedDialogWrapper from '../../../../util/AnimatedDialogWrapper'
import $ from "jquery";
import Button from "../../../../components/Button";
import messageResource from "../../../../messageResource";
import BulkInvitationsDropdown from './BulkInvitationsDropdown'
import ClassicBridge from '../../../../next/ClassicBridge'

export class ManagementButtonsContainer extends TemplateView {
    constructor({
        onManageUserDepartmentsClick = () => {},
        onManageTimeZoneGroupsClick = () => {},
        onAddNewUserClick = () => {},
        onManualInvitationsClick = () => {},
        onImportUsersFinished = (importedUsersData) => {},
    }) {
        super(null)

        this.state = {
            isUGREnabled: false,
            isTZGEnabled: false,
            isPossibleToCreateUsers: false,
            licenseViolated: false,
            isCsvUserImportModalShown: false,
        }

        this.callbacks = {
            onManageUserDepartmentsClick,
            onManageTimeZoneGroupsClick,
            onAddNewUserClick,
            onManualInvitationsClick,
            onImportUsersFinished,
        }

        this.onStatePropertyChanged('isCsvUserImportModalShown', () => {
            this._setModalProperties({
                isShown: this.state.isCsvUserImportModalShown,
                onClose: this._closeCsvUserImportModal,
            })
        })

        this.onAnyStatePropertyChanged(['isUGREnabled', 'isTZGEnabled'], () => {
            this.manageGroupsButton.setState({
                isUGREnabled: this.state.isUGREnabled,
                isTZGEnabled: this.state.isTZGEnabled,
            })

            this.manageGroupsButton.toggle(this.state.isUGREnabled || this.state.isTZGEnabled)
        })

        this.onStatePropertyChanged('isPossibleToCreateUsers', () => {
            this.addNewUserButton.setState({
                disabled: !this.state.isPossibleToCreateUsers
            })

            if (this.inviteUsersButton) {
                this.inviteUsersButton.setState({
                    disabled: !this.state.isPossibleToCreateUsers
                })
            }
        })

        this.onStatePropertyChanged('licenseViolated', () => {
            this.manageGroupsButton.setState({disabled: this.state.licenseViolated})
        })

        this._handleManageGroupsButtonClick = this._handleManageGroupsButtonClick.bind(this)
    }


    templateHtml() {
        return '<div class="userList_container_managementButtonsContainer">' +
               '  <div class="manageGroups"></div>' +
               '</div>'
    }

    afterRender() {
        const { setProps } = ClassicBridge.integrateCsvUserImportModal(this.$el[0])
        this._setModalProperties = setProps

        this.manageGroupsButton = new ManageGroupsButton({
            onButtonClick: this._handleManageGroupsButtonClick
        }).init(this.$el)
        this.manageGroupsButton.hide()

        this.manageGroupsDialog = new AnimatedDialogWrapper(null, {
            className: 'userList_manageButtons_component_manageGroupsList',
            toggleMode: true, // TODO not working :(
            dialog: new ManageGroupsList({
                departmentsOnClick: () => {
                    this.manageGroupsDialog.hide()
                    this.callbacks.onManageUserDepartmentsClick()
                },
                timeZoneOnClick: () => {
                    this.manageGroupsDialog.hide()
                    this.callbacks.onManageTimeZoneGroupsClick()
                },
            }),
            autoPosition: true,
        }).init($('body'))

        this.addNewUserButton = new Button({
            label: messageResource.getMessage('userlist.add_new_user'),
            withPlusIcon: true,
            onClickCb: this.callbacks.onAddNewUserClick
        }).init(this.$el)

        if (isOlVersion || isDemoVersion) {
            const inviteUsersDropdown = new AnimatedDialogWrapper(null, {
                className: 'userList_invitationButtonsDropdown',
                toggleMode: true,
                dialog: new BulkInvitationsDropdown({
                    manualInvitationsClick: () => {
                        inviteUsersDropdown.hide()
                        this.callbacks.onManualInvitationsClick()
                    },
                    csvImportClick: () => {
                        inviteUsersDropdown.hide()
                        this._openCsvUserImportModal()
                    },
                }),
                autoPosition: true,
            }).init($('body'))

            this.inviteUsersButton = new Button({
                label: messageResource.getMessage('userlist.bulk_invitations'),
                additionalClass: 'addSeveralUsersButton dropdown',
                onClickCb: () => {
                    inviteUsersDropdown.showAt(this.inviteUsersButton.getEl(), {
                        my: 'right top',
                        at: 'right bottom',
                    })
                },
            }).init(this.$el)
        } else {
            this.inviteUsersButton = new Button({
                label: messageResource.getMessage('userlist.csv_import'),
                additionalClass: 'addSeveralUsersButton',
                onClickCb: this._openCsvUserImportModal,
            }).init(this.$el)
        }
    }

    _openCsvUserImportModal = () => {
        this.setState({ isCsvUserImportModalShown: true })
    }

    _closeCsvUserImportModal = (importedUsersData) => {
        this.callbacks.onImportUsersFinished(importedUsersData)
        this.setState({ isCsvUserImportModalShown: false })
    }

    _handleManageGroupsButtonClick = () => {
        if (this.state.isUGREnabled && this.state.isTZGEnabled) {
            this.manageGroupsDialog.showAt(
                this.manageGroupsButton.getEl(),
                {
                    my: 'left top',
                    at: 'left bottom',
                })
        } else if (this.state.isUGREnabled) {
            this.callbacks.onManageUserDepartmentsClick()
        } else if (this.state.isTZGEnabled) {
            this.callbacks.onManageTimeZoneGroupsClick()
        }
    }
}

export default connect((state) => {
    return {
        isUGREnabled: isUGREnabled(state),
        isTZGEnabled: isTZGEnabled(state),
        isPossibleToCreateUsers: isPossibleToCreateUsers(state),
        licenseViolated: licenseViolated(state),
    }
})(ManagementButtonsContainer)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/managementButtons/ManagementButtonsContainer.js